import { useCallback, useMemo, useState } from 'react'

import { useWhyWeInvestQuery } from 'src/app/home/repositories/use-why-we-invest-query'

import { ICompany, IUseWhyWeInvestReturn } from '../types'

export const useWhyWeInvest = (): IUseWhyWeInvestReturn => {
  const { data, isLoading, isError, refetch } = useWhyWeInvestQuery()
  const [query, setQuery] = useState<string>('')
  const [selectedCompany, setSelectedCompany] = useState<ICompany | null>(null)

  const companies = useMemo<ICompany[]>(() => data ?? [], [data])

  const filteredCompanies = useMemo(() => {
    const normalized = query.trim().toLowerCase()
    if (!normalized) {
      return companies
    }
    return companies.filter(company =>
      company.name.toLowerCase().includes(normalized),
    )
  }, [companies, query])

  const openCompany = useCallback((company: ICompany): void => {
    setSelectedCompany(company)
  }, [])

  const closeCompany = useCallback((): void => {
    setSelectedCompany(null)
  }, [])

  const handleRefetch = useCallback((): void => {
    void refetch()
  }, [refetch])

  return {
    query,
    setQuery,
    filteredCompanies,
    hasResults: filteredCompanies.length > 0,
    isLoading,
    isError,
    refetch: handleRefetch,
    selectedCompany,
    openCompany,
    closeCompany,
  }
}
